import { useCallback, useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITextInput from 'UIComponents/input/UITextInput';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddGuestsField = ({
  guestEmail,
  guestCount,
  errorMessage,
  tooltipMessage,
  isValidatingEmail,
  maxGuestCount,
  handleInputChange,
  handleAddGuest
}) => {
  const hasError = errorMessage !== null;
  const reachedMaxGuestCount = guestCount === maxGuestCount;
  const addButtonDisabled = hasError || guestEmail.length === 0 || reachedMaxGuestCount || isValidatingEmail;
  const renderedAddButton = useMemo(() => {
    const button = /*#__PURE__*/_jsx(UILoadingButton, {
      "data-selenium-test": "meetings-add-guests-field-add-btn",
      "data-test-id": "meetings-add-guests-field-add-btn",
      className: "m-left-2 flex-shrink-0",
      use: "tertiary-light",
      onClick: handleAddGuest,
      disabled: addButtonDisabled,
      loading: isValidatingEmail,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "add"
      })
    });
    const hasTooltipMessage = tooltipMessage !== null;
    if (hasTooltipMessage) {
      return /*#__PURE__*/_jsx(UITooltip, {
        title: tooltipMessage,
        children: button
      });
    }
    return button;
  }, [addButtonDisabled, isValidatingEmail, tooltipMessage, handleAddGuest]);
  const handleEnterKeyPress = useCallback(evt => {
    const charCode = evt.key || evt.code;
    if (!charCode) return;
    const enterKeyPressed = charCode.toLowerCase() === 'enter';
    if (enterKeyPressed && !addButtonDisabled) {
      handleAddGuest();
    }
  }, [handleAddGuest, addButtonDisabled]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "prebook.details.addGuests.maxGuestCountReached"
    }),
    disabled: !reachedMaxGuestCount,
    children: /*#__PURE__*/_jsxs(UIInputGroup, {
      "data-test-id": "meetings-add-guests-field",
      className: "p-x-2 width-100",
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": I18n.text('prebook.details.addGuests.inputAriaLabel'),
        validationMessage: errorMessage,
        error: hasError,
        children: /*#__PURE__*/_jsx(UITextInput, {
          "data-selenium-test": "meetings-add-guests-field-input",
          "data-test-id": "meetings-add-guests-field-input",
          value: guestEmail,
          onChange: handleInputChange,
          onKeyDown: handleEnterKeyPress,
          disabled: reachedMaxGuestCount,
          placeholder: I18n.text('prebook.details.addGuests.inputPlaceholder')
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": I18n.text('prebook.details.addGuests.addButtonAriaLabel'),
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [renderedAddButton, /*#__PURE__*/_jsx(Small, {
            className: "m-y-0 p-x-2 align-self-center",
            use: "help",
            wrap: "true",
            weight: "bold",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "prebook.details.addGuests.guestCount",
              options: {
                currentCount: guestCount,
                maxCount: maxGuestCount
              }
            })
          })]
        })
      })]
    })
  });
};
export default AddGuestsField;